export default {
  name: 'SHUserPicker',
  data() {
    return {
      apis: {
        list: 'sh/user/list', //获取人员列表，根据主键
        tags: 'sh/tag/list',//获取标签列表
      },
      pickerProps: {
        key: 'id',
        label: 'name'
      },
      params: {
        tags:[],//用户组
        keyword: null, //查询条件
        status: 1, //仅查询正常状态的人
      },
      users: [], //备选人员
      selections: [], //已选人员
      exist:[],//已经存在的
      org:null,//选中组织机构
      curOrgKey: null, //组织机构主键
      tags:[],//标签
    };
  },
  props: {
      multiple: { //允许多选
          type: Boolean,
          default: false
      },
      userKeys: Array, //默认存在的用户
      orgKey: String,//指定机构，如果指定该参数，则仅仅加载该机构及其子机构,
      orgCode:String, //指定机构，如果指定该参数，则仅仅加载该机构及其子机构
  },
  mounted() {
      const me = this;
      me.selections = [];
      if (me.userKeys && me.userKeys.length > 0) {
          me.initSelection();
      }
      me.curOrgKey = me.orgId;
      me.loadTag();
  },
  methods: {
    loadUser(){//获取备选人员列表
        const me = this;
        me.$set(me.params, 'orgPath', me.org.keyPath);
        me.$post({
            url: me.apis.list,
            params: me.params
        }).then(rsp => {
            me.users = rsp.retList;
        });
    },
    initSelection(){//初始化已经存在的人员列表
        const me = this;
        me.selections = [];
        if (!!!me.userKeys || me.userKeys.length <= 0) {
            return;
        }
        me.$post({
            url: me.apis.list,
            params: {
              keys : me.userKeys
            }
        }).then(rsp => {
           me.selections = rsp.retList;
        });
    },
    getUsers() {//获取选中的人员主键列表
        const me = this, keys = [];
        if(me.selections && me.selections.length > 0){
          for(let i in me.selections){
            keys.push(me.selections[i].id);
          } 
        }
        return keys;
    },
    getUserObj(){//获取选中人员对象列表
        return this.selections;
    },
    userClick(row, col, e){//双击备选人员时执行，如果人员存在于已选列表，则从已选列表删除，否则添加到已选列表
      const me = this;
      me.selections = me.selections ? me.selections : [];
      if(!me.multiple || (me.selections.length == 0)){
          me.selections = [];
          me.selections.push(row);
      }else{
          for(let i in me.selections){
              if(me.selections[i].id == row.id){
                  return;
              }
          }
          me.selections.push(row);
      }
    },
    orgClick(data) {//组织机构树单击时执行，对备选人员进行过滤
        const me = this;
        me.org = data.org;
        me.loadUser();
    },
    orgLoad(orgs, root) {//组织机构数据加载完成时执行，加载所有人员
        const me = this;
        me.orgClick({org:root});
    },
    delUser(row){//删除指定已选人员
      const me = this, table = me.$refs['user_list_table'];
      for(let i in me.selections){
        if(me.selections[i].id == row.id){
          me.selections.splice(i, 1);
          return;
        }
      }
    },
    selectAll(){//选择全部
        const me = this;
        for(let i in me.users){
          me.userClick(me.users[i]);
        }
    },
    clear(){//清空
        this.selections = [];
    },
    loadTag(){//获取用户组备选清单
      const me = this;
      me.$post({
          url: me.apis.tags,
          params:{}
      }).then(rsp => {
          me.tags = rsp.retList;
      })
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/base/view/Org/cmps/user/picker/src/picker.js